import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "prop-container"
};
const _hoisted_2 = {
  class: "prop-info-container"
};
const _hoisted_3 = {
  class: "props-name"
};
const _hoisted_4 = {
  key: 0,
  class: "props-times"
};
const _hoisted_5 = {
  class: "props-type"
};
const _hoisted_6 = {
  class: "props-price"
};
const _hoisted_7 = {
  class: "props-price"
};
const _hoisted_8 = {
  class: "prop-desc-container"
};
const _hoisted_9 = {
  class: "item-content"
};
const _hoisted_10 = {
  class: "item-content"
};
const _hoisted_11 = {
  class: "item-content"
};
const _hoisted_12 = {
  key: 1
};
const _hoisted_13 = {
  class: "item-content"
};
import { ElRow } from 'element-plus';
import { isValid, parseToCostDesc, propsDefaultImage } from '@/tools/utils';
import 'element-plus/es/components/input-number/style/css'; // pre-declaration

export default {
  __name: 'StagePropsCard',
  props: {
    data: {
      type: Object,
      required: true
    }
  },

  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");

      return __props.data ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(ElRow), {
        style: {
          "align-items": "center"
        }
      }, {
        default: _withCtx(() => [__props.data?.image ? (_openBlock(), _createBlock(_component_el_image, {
          key: 0,
          class: "prop-image",
          src: __props.data.image && __props.data.image.length > 0 ? __props.data.image : _unref(propsDefaultImage),
          draggable: "false"
        }, null, 8, ["src"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_createVNode(_unref(ElRow), null, {
          default: _withCtx(() => [_createElementVNode("text", _hoisted_3, [_createTextVNode(_toDisplayString(__props.data.name) + " ", 1), __props.data?.type && __props.data.type.is_stackable ? (_openBlock(), _createElementBlock("span", _hoisted_4, "  x " + _toDisplayString(__props.data.times), 1)) : _createCommentVNode("", true)])]),
          _: 1
        }), __props.data?.tag ? (_openBlock(), _createBlock(_unref(ElRow), {
          key: 0
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_5, _toDisplayString(__props.data.type.desc) + " / " + _toDisplayString(__props.data.tag.desc), 1), _createElementVNode("div", {
            class: _normalizeClass([`rare-${__props.data.rare_level}`, 'rare-tag'])
          }, _toDisplayString(__props.data.rare_desc), 3)]),
          _: 1
        })) : _createCommentVNode("", true), __props.data?.price ? (_openBlock(), _createBlock(_unref(ElRow), {
          key: 1,
          style: {
            "gap": "16px"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("text", _hoisted_6, " 重 " + _toDisplayString(props.data.weight ? `${props.data.weight} kg` : '不计'), 1), _createElementVNode("text", _hoisted_7, " 价 " + _toDisplayString(parseFloat(__props.data.price).toFixed(1)) + " 点 ", 1)]),
          _: 1
        })) : _createCommentVNode("", true)])]),
        _: 1
      }), _createElementVNode("div", _hoisted_8, [_createVNode(_unref(ElRow), {
        class: "item-row"
      }, {
        default: _withCtx(() => [_cache[0] || (_cache[0] = _createElementVNode("text", {
          class: "item-tag"
        }, "形态描述", -1)), _createElementVNode("text", _hoisted_9, "    " + _toDisplayString(__props.data['appearance_desc']), 1)]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        class: "item-row"
      }, {
        default: _withCtx(() => [_cache[1] || (_cache[1] = _createElementVNode("text", {
          class: "item-tag"
        }, "性能描述", -1)), _createElementVNode("text", _hoisted_10, "    " + _toDisplayString(__props.data['function_desc']), 1)]),
        _: 1
      }), __props.data['deep_desc'] ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 0,
        class: "item-row"
      }, {
        default: _withCtx(() => [_cache[2] || (_cache[2] = _createElementVNode("text", {
          class: "item-tag"
        }, "深层信息", -1)), _createElementVNode("text", _hoisted_11, "    " + _toDisplayString(__props.data['deep_desc']), 1)]),
        _: 1
      })) : _createCommentVNode("", true), _unref(isValid)(__props.data.cost) ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_unref(ElRow), {
        class: "item-row"
      }, {
        default: _withCtx(() => [_cache[3] || (_cache[3] = _createElementVNode("text", {
          class: "item-tag"
        }, "道具消耗", -1)), _createElementVNode("text", _hoisted_13, "    " + _toDisplayString(_unref(parseToCostDesc)(__props.data.cost)), 1)]),
        _: 1
      })])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true);
    };
  }

};